import { apiCall } from './authAPI';
import { buildApiUrl } from './config';

export const themeSettingsAPI = {
  getPublicTheme: async () => {
    const response = await fetch(buildApiUrl('/theme-settings'));
    return response.json();
  },

  getAdminTheme: async () => apiCall('/theme-settings/admin', 'GET'),

  updateTheme: async (payload) => apiCall('/theme-settings/admin', 'PUT', payload),

  resetTheme: async () => apiCall('/theme-settings/admin/reset', 'POST', {})
};

export default themeSettingsAPI;